import React from 'react'
import { Container, Breadcrumb, Meta, User, FormRow } from '../../../components'
import routes from './routes'
import { useLocation } from 'react-router-dom'
import { ShareButtons } from './share-buttons'
// import { ActionButtons } from './action-buttons'

const TypeBook = () => {
  const location = useLocation()
  const special = location.search.includes('special')

  return (
    <Container className="py-5 lg:py-20" color="#f5f5f5">
      <div className="flex flex-wrap -mx-4">
        <div className="w-full lg:w-6/12 px-4 lg:pr-8 mb-5 lg:mb-0">
          <img className="w-full" src="/images/khub_ebook_reader.jpg" alt="ebook"/>
        </div>
        <div className="lg:w-6/12 px-4">
          <div className="mb-4">
            <Breadcrumb routes={routes} />
          </div>
          <div className="lg:hidden">
            <div className="text-xs font-bold mb-3">Fri, Aug 14 2020  - Sun, Aug 16 2020 </div>
          </div>
          {
            special &&
            <div className="rounded px-1 text-white text-xs mb-4 inline-block" style={{background: '#FF5448'}}>Special Resource</div>
          }
          <h1 className="text-2xl lg:text-4xl font-bold font-primary mb-4 lg:mb-5 leading-tight">019 Fringe Programme</h1>
          <div className="w-3/4 lg:w-full flex flex-wrap -mx-2 lg:-mx-4 mb-1 lg:mb-8">
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Type"
                value="Video"
              />
            </div>
            {/* <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-4 lg:mb-0"
                label="Suitable for"
                value="Educator, Donor, Professionals"
              />
            </div> */}
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-6 lg:mb-0"
                label="Approach"
                value="Pencegahan"
              />
            </div>
            <div className="w-1/2 lg:w-1/3 px-2 lg:px-4">
              <Meta
                className="mb-6 lg:mb-0"
                label="Issues"
                value="Pemuda, Pelajar"
              />
            </div>
          </div>
          <FormRow>
            <User name="AIPJ2"/>
          </FormRow>
          <hr className="my-6 lg:my-10" style={{ borderColor: '#ddd' }}/>
          <p className="text-gray-444 mb-8 lg:mb-10 text-sm">
          Laboris qui ut eiusmod anim aliquip elit adipisicing cillum deserunt non consequat quis. Adipisicing nisi nostrud deserunt deserunt enim duis commodo elit consectetur.
          </p>

          {/* <ActionButtons /> */}

          <hr className="my-8 lg:my-10"/>
          <ShareButtons />
        </div>
      </div>
    </Container>
  )
}

export { TypeBook }